<script>
  import TeaColor from './TeaColor.svelte';
  export let row;
  export let index;
</script>

<div class="text-sm hidden md:block">
  {index + 1}
</div>
<div>
  <TeaColor colorName={row.category ? row.category[0] : ''}></TeaColor>
</div>
<div>
  {#if row.bio}<img
      src="/img/bio-256.png"
      alt="bio"
      width="16"
      height="16"
      class="mr-2"
    />{/if}
</div>
<div class={row.detail ? 'cursor-help' : ''} title={row.brand ? row.brand : ''}>
  {row.name ? row.name : ''}
  <div class="text-gray-500 text-xs block md:hidden">
    <span class="">{row.detail ? row.detail : row.brand ? row.brand : ''}</span>
  </div>
</div>
<div class="text-gray-700 hidden md:block">
  <span class="">{row.detail ? row.detail : ''}</span>
</div>
